import consumer from '../channels/consumer';
import { Helpers } from '../helpers';

const VERIFICATION_MIN_DELAY = 3000;

/**
 * Subscribes to the SubscriptionIntentionChannel.
 * Enforces a minimum display time on the verification step.
 *
 * @returns {Object} ActionCable subscription (call .unsubscribe())
 */
export function subscribeToIntention(intentionId, {onSuccess, onError}) {
  const shownAt = Date.now();

  return consumer.subscriptions.create(
    {
      channel: 'SubscriptionIntentionChannel',
      subscription_intention_id: intentionId,
    },
    {
      received: (data) => {
        const elapsed = Date.now() - shownAt;
        const remaining = Math.max(0, VERIFICATION_MIN_DELAY - elapsed);

        setTimeout(() => {
          if (data.status === 'success' && data.subscription_id) {
            onSuccess(data.subscription_id);
          } else {
            onError();
          }
        }, remaining);
      },
    }
  );
}

/**
 * Subscribes to the SignatureChannel.
 *
 * Callbacks:
 *   onSigned({paymentPending, missingAmountFormatted})
 *   onSignatureReady({signingUrl, finalizeUrl, documentUrl})
 *   onError()
 *
 * @returns {Object} ActionCable subscription (call .unsubscribe())
 */
export function subscribeToSignature(subscriptionId, {onSigned, onSignatureReady, onError}) {
  return consumer.subscriptions.create(
    {
      channel: 'SignatureChannel',
      subscription_id: subscriptionId,
    },
    {
      rejected: () => onError(),
      received: (data) => {
        if (data.status === 'error') {
          onError();
          return;
        }

        if (data.status === 'signed') {
          const missingAmountFormatted = data.missing_amount
            ? Helpers.numberToCurrency(data.missing_amount, 2)
            : null;

          onSigned({
            paymentPending: data.payment_pending,
            missingAmountFormatted,
          });
          return;
        }

        if (data.signing_url || data.document_url) {
          onSignatureReady({
            signingUrl: data.signing_url,
            finalizeUrl: data.finalize_url,
            documentUrl: data.document_url,
          });
        }
      },
    }
  );
}
